import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchCustomerSegmentsList = createAsyncThunk("fetchCustomerSegmentsList", async ({ filters, page, limit }, { rejectWithValue }) => {
	try {
		const params = new URLSearchParams({
			page: page,
			limit: limit,
			keyword: filters?.keyword ?? "",
			channel_uuid: filters?.channel_uuid ?? "",
		});

		const response = await axiosHttp.get(`customer-segments?${params}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong while fetching customer segments");
	}
});

const CustomerSegmentsListSlice = createSlice({
	name: "CustomerSegmentsListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchCustomerSegmentsList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchCustomerSegmentsList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage || 1;
			state.total = action.payload.total || 0;
		});

		builder.addCase(fetchCustomerSegmentsList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || action.error.message || "Unknown error occurred";
		});
	},
});

export default CustomerSegmentsListSlice.reducer;
